export const ENTITIES_ADD = 'clients/ENTITIES_ADD';
export const NETWORK_START = 'clients/NETWORK_START';
export const NETWORK_RESET = 'clients/NETWORK_RESET';
export const NETWORK_ERROR = 'clients/NETWORK_ERROR';
export const ACTIVE_SET = 'clients/ACTIVE_SET';
export const SEARCH_SET = 'clients/SEARCH_SET';



// WEBPACK FOOTER //
// ./src/modules/clients/actionTypes.js